var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"aside is-placed-right"},[_c('div',{ref:"container",staticClass:"aside-container has-padding",on:{"mouseenter":_vm.psUpdate}},[_c('aside-updates',{on:{"data-updated":_vm.psInit}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }